import { Attributes, Misc, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class DividendAccrualDetailCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dividend Accrual Detail Criteria";
    }
}